import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Button, Space, Tag, Checkbox, message } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../utils/api';

// Shown at the top of every page. Each user sees the tasks (work) an admin assigned
// to them (or to everyone) and can tick them as Done.
export default function TaskBanner() {
  const [tasks, setTasks] = useState([]);

  const fetchTasks = useCallback(async () => {
    try {
      const res = await api.get('/tasks');
      setTasks((res.data || []).filter(t => t.status !== 'done'));
    } catch (err) { /* tasks table may not exist yet */ }
  }, []);

  useEffect(() => { fetchTasks(); }, [fetchTasks]);

  const markDone = async (id) => {
    try {
      await api.post(`/tasks/${id}/done`, { done: true });
      setTasks(t => t.filter(x => x.id !== id));
      message.success('Task completed!');
    } catch (err) { message.error('Failed'); }
  };

  if (tasks.length === 0) return null;

  return (
    <Alert
      type="warning"
      showIcon
      icon={<BellOutlined />}
      style={{ marginBottom: 16, borderRadius: 10 }}
      message={<b>Your Tasks for Today — {tasks.length}</b>}
      description={
        <Space direction="vertical" style={{ width: '100%' }}>
          {tasks.map(t => (
            <div key={t.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
              <Space>
                <Checkbox onChange={() => markDone(t.id)} />
                <span style={{ fontWeight: 500 }}>{t.title}</span>
                {t.priority === 'urgent' && <Tag color="red">URGENT</Tag>}
                {t.task_date && <Tag color="blue">{dayjs(t.task_date).format('DD MMM')}</Tag>}
              </Space>
              <Button size="small" type="primary" onClick={() => markDone(t.id)}>Done</Button>
            </div>
          ))}
        </Space>
      }
    />
  );
}
